import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Modal } from "react-bootstrap";

import AddFieldPage from "./AddFieldPage";
import EditFieldPage from "./EditFieldPage";

import ContextComponent from "../../../../AppContext";
import DataTable from "../../../../controls/table/DataTable";
import AddIcon from "../../../../../assets/img/add.png";
import EditIcon from "../../../../../assets/img/Edit.png";
import SaveIcon from "../../../../../assets/img/Save.png";
import DeleteIcon from "../../../../../assets/img/Delete.png";
import EmptyPage from "../../../../pages/EmptyPage";
import Utils from "../../../../Utils";

function Fields() {
  const { siteid } = useParams();
  let { setCanRedirectToLogin, setLoadingState, setAlert, userData } =
    useContext(ContextComponent);

  let [admin, setAdmin] = useState(false);
  let [superAdmin, setSuperAdmin] = useState(false);

  let [currSiteId, setCurrSiteId] = useState(siteid);
  let [siteName, setSiteName] = useState("");
  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [selectedItemCount, setSelectedItemCount] = useState(0);

  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);
  let [saveIconClass, setSaveIconClass] = useState(DISABLED_ICON);

  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [fieldForEdit, setFieldIdForEdit] = useState("");
  let [allFields, setAllFields] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setFieldIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setFieldIdForEdit("");
    }
  }, [tableSelectedItems]);

  useEffect(() => {
    setAdmin(!!userData?.admin);
    setSuperAdmin(!!userData?.superAdmin);
  }, [admin, superAdmin, userData]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  let [editableField, setEditableField] = useState({});
  let [editableFieldIndex, setEditableFieldIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetField = {};
    allFields.forEach((fieldItem, index) => {
      if (fieldItem.id === fieldForEdit) {
        targetField = fieldItem;
        setEditableFieldIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetField) && setEditableField(targetField);
  };

  // write useEffect to get all the data for an API Call

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "fieldcode",
    "displayname",
    "type",
    "activestatus",
    "required",
    "order"
  ]);
  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
    },
    fieldcode: {
      type: "text",
      search: false,
      sort: false,
      title: "Field Code",
    },
    displayname: {
      type: "text",
      search: false,
      sort: false,
      title: "Display Name",
    },
    type: {
      type: "text",
      search: false,
      sort: false,
      title: "Field Type",
    },
    activestatus: {
      type: "boolean",
      title: "Show",
      disabled: true,
      center: true,
    },
    required: {
      type: "boolean",
      title: "Required",
      disabled: true,
      center: true,
    },
    order: {
      type: "order",
      search: false,
      sort: true,
      title: "Order",
    },
  });

  let [tableData, setTableData] = useState([]);
  let [canRender, setCanRender] = useState(false);
  let [renderDataTable, setRenderDataTable] = useState(false);
  let [renderEmptyPage, setRenderEmptyPage] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  let [orderChanged, setOrderChanged] = useState({});

  function getFieldNameFromValue(value) {
    const fieldTypeObj = Utils.FIELD_TYPE.find(field => field.value === value);
    return fieldTypeObj ? fieldTypeObj.name : "";
  }

  const updateTableData = (data) => {
    setAllFields(data);
    let FieldInfo = data;
    let FieldsArray = [];
    if (!Utils.isObjectEmpty(FieldInfo)) {
      FieldsArray = FieldInfo.map((fieldData, index) => {
        let fieldTableObj = [];
        let fieldTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            fieldTableData.push(false);
          } else if (col === "activestatus") {
            let valueToBePush = FieldInfo?.[index]?.['activestatus'] || false;
            fieldTableData.push(valueToBePush);
          } else if (col === "required") {
            let valueToBePush = FieldInfo?.[index]?.['required'] || false;
            fieldTableData.push(valueToBePush);
          } else if (col === "type") {
            let tempValue = FieldInfo?.[index]?.['type'];
            let valueToBePush = getFieldNameFromValue(tempValue);
            fieldTableData.push(valueToBePush);
          } else {
            fieldTableData.push(FieldInfo[index][col]);
          }
        });
        fieldTableObj = fieldTableData;
        return fieldTableObj;
      });
      let name = data[0]?.site ?? '';
      name.length > 0 && setSiteName("(" + name + ")");
      setTableData(FieldsArray);
      setCanRender(true);
    }
  };

  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadFreshFields = (currSiteId) => {
    Utils.getAllFieldsBySitedId({ siteId: currSiteId }).then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading fields",
    });
    loadFreshFields(currSiteId);
  }, []);

  useEffect(() => {
    if (tableData.length) {
      // console.log("table has data now");
    }
  }, [tableData]);

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Field(s) deleted successfully",
      type: "success"
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
    setAlert({
      show: true,
      message: "Field(s) deletion failed",
      type: "danger",
    });

  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    // Refactored to ensure that order is reset after deletion
    let tempTableData = tableData
      .filter((d) => tableSelectedItems.indexOf(d[0]) === -1)
      .map((row, i) => {
        let orderIndex = tableColumns.indexOf("order");
        row[orderIndex] = i + 1; // reset order starting from 1
        return row;
      });
    setTableData(tempTableData);
    console.log(tempTableData);
    Utils.deleteFields(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  let [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };

  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };

  useEffect(() => {
    if (Object.keys(orderChanged).length > 0) {
      let action = orderChanged.action;
      // let currentIdx = (parseInt(orderChanged.current, 10)) - 1;
      let currentIdx = parseInt(orderChanged.current, 10); // changed to rowIndex so zero-based
      let targetIdx = action === "plus" ? currentIdx + 1 : currentIdx - 1;

      setOrderChanged({});

      let orderIndex = tableColumns.indexOf("order");

      // deep clone the table data
      let currentTableDataTemp = JSON.parse(JSON.stringify(tableData));

      // swap rows
      let temp = currentTableDataTemp[currentIdx];
      currentTableDataTemp[currentIdx] = currentTableDataTemp[targetIdx];
      currentTableDataTemp[targetIdx] = temp;

      // update the order property
      currentTableDataTemp.forEach((row, i) => {
        row[orderIndex] = i + 1; // order starts from 1
      });

      setTableData(currentTableDataTemp);
      setSaveIconClass("");
    }

  }, [orderChanged]);

  const handleSaveOrder = (e) => {
    // console.log("in handleSaveOrder...");
    // console.log(tableData);

    setLoadingState({
      applyMask: true,
      text: "Saving order",
    });

    const saveOrderSuccess = (res) => {
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: res?.data?.message
          ? res.data.message
          : "Order saved successfully!",
        type: "success",
      });
    };

    const saveOrderFail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      err?.message?.length && console.log(err);
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: err?.data?.message
          ? err.data.message
          : "Order save failed",
        type: "danger",
      });
    };

    let orderObj = [];
    tableData.forEach((item) => {
      orderObj.push(item[0]);
    });

    Utils.saveOrderForSiteFields({ siteId: siteid, orderObj }).then(saveOrderSuccess, saveOrderFail);

  }



  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        <span>Fields <span className="indi-site-name-in-header">{siteName}</span></span>
        <div className="d-none1 w-50 indi-body-actions">
          {(admin || superAdmin) && (
            <div
              className="indi-body-action"
              role="button"
              onClick={openAddModal}
            >
              <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
              Add
            </div>
          )}
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>
          <div
            className={`indi-body-action ${saveIconClass}`}
            role="button"
            onClick={handleSaveOrder}
          >
            <img className="indi-w-20" src={SaveIcon} alt="save-icon"></img>
            Save
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
                setOrderChanged,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No Fields are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} item(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddFieldPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadFreshFields,
          }}
        />
      )}
      {editModalCanOpen && (
        <EditFieldPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableField,
            editableFieldIndex,
            allFields,
            setAllFields,
            loadFreshFields,
          }}
        />
      )}
    </div>
  );
}

export default Fields;
